import {useToast} from 'vue-toastification';

const toast = useToast();

export function errorOutput(message = '', err = null, actionName = '') {
    let errStr = '';
    // if(err) {
    //     console.log(err);
    // }
    if (err && typeof err === 'string') {
        errStr = err;
    } else if (err && err.response && err.response.data && err.response.data.message) {
        errStr = getStrData(err.response.data.message);
    } else if (err && err.status && err.status === 'operation_fail' && err.message) {
        errStr = getStrData(err.message);
    } else if (err && err.message) {
        errStr = getStrData(err.message);
    } else if (err && typeof err === 'object' && !Array.isArray(err)) {
        errStr = getStrData(err);
    }
    if (err && errStr === '') {
        errStr = err.toString();
    }
    if (message !== '' && errStr && typeof errStr === 'string' && errStr !== '') {
        toast.error(message + '\n' + errStr);
    } else {
        toast.error(message);
    }
    EventBus.$emit('error_data', actionName);
}

function getStrData(errData) {

    if (typeof errData === 'object') {
        return JSON.stringify(errData);
    }
    return errData;
}
